import type { IWallet } from 'oscar-typedef'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useWalletAPIStore } from '@/stores'
import { RemainTime } from '@/types'

interface FilterbyWalletID {
  id: IWallet['id']
  boolean?: boolean
  data?: string | number | NodeJS.Timer | RemainTime
}

const usePinLockStore = defineStore('pinLock', () => {
  const walletAPIStore = useWalletAPIStore()
  const isPinLockList = ref<FilterbyWalletID[]>([])
  const isPinUnlockableList = ref<FilterbyWalletID[]>([])
  const isPinRemainTryCount = ref<FilterbyWalletID[]>([])
  const isPinRemainTime = ref<FilterbyWalletID[]>([])
  const isPinUnlockDate = ref<FilterbyWalletID[]>([])
  const isPinIntervalList = ref<FilterbyWalletID[]>([])
  const pinTryCountFetchList = ref<string[]>([])

  const setLocked = (id: IWallet['id'], boolean: boolean) => {
    const result = isPinLockList.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.boolean = boolean)
    }
    isPinLockList.value.push({
      id,
      boolean,
    })
  }
  const setUnlockable = (id: IWallet['id'], boolean: boolean) => {
    const result = isPinUnlockableList.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.boolean = boolean)
    }
    isPinUnlockableList.value.push({
      id,
      boolean,
    })
  }

  const setRemainTryCount = (id: IWallet['id'], data: number) => {
    const result = isPinRemainTryCount.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.data = data)
    }
    isPinRemainTryCount.value.push({
      id,
      data,
    })
  }

  const setRemainTime = (id: IWallet['id'], data: RemainTime) => {
    const result = isPinRemainTime.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.data = data)
    }
    isPinRemainTime.value.push({
      id,
      data,
    })
  }

  const setUnlockDate = (id: IWallet['id'], data: string) => {
    const result = isPinUnlockDate.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.data = data)
    }
    isPinUnlockDate.value.push({
      id,
      data,
    })
  }

  const setIntervalList = (id: IWallet['id'], data: NodeJS.Timer) => {
    const result = isPinIntervalList.value.find(
      (lock: FilterbyWalletID) => lock.id === id,
    )
    if (result) {
      return (result.data = data)
    }
    isPinIntervalList.value.push({
      id,
      data,
    })
  }

  const getKeyInfo = async (walletId?: string) => {
    if (typeof walletId === 'undefined' || walletId === null) return 0
    return await walletAPIStore.fetchWalletKeyInfo(walletId!)
  }

  const getResetPinTryCount = async (walletId?: IWallet['id']) => {
    if (typeof walletId === 'undefined' || walletId === null) return 0
    return await walletAPIStore.resetPinTryCount(walletId!)
  }

  const setPinTryCountFetchList = (id: IWallet['id']) => {
    if (pinTryCountFetchList.value?.indexOf(id) === -1) {
      pinTryCountFetchList.value?.push(id)
    }
  }

  const reset = () => {
    isPinLockList.value = []
    isPinUnlockableList.value = []
    pinTryCountFetchList.value = []
    isPinRemainTryCount.value = []
  }
  return {
    pinTryCountFetchList,
    setPinTryCountFetchList,
    getResetPinTryCount,
    getKeyInfo,
    isPinLockList,
    isPinUnlockableList,
    isPinRemainTryCount,
    isPinRemainTime,
    isPinUnlockDate,
    isPinIntervalList,
    setLocked,
    setUnlockable,
    setRemainTryCount,
    setRemainTime,
    setUnlockDate,
    setIntervalList,
    reset,
  }
})

export { usePinLockStore }
